<template>
    <transition name="fade">
        <div v-if="categories.length" class="shop-filter-component mdc-tab-bar" role="tablist">
            <div class="mdc-tab-scroller">
                <div class="mdc-tab-scroller__scroll-area">
                    <div class="mdc-tab-scroller__scroll-content">
                        <button @click="setFilter({ case: 'all' })" class="mdc-tab mdc-tab--active category-filter-btn"
                            role="tab" id="all" aria-selected="true" tabindex="1">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">{{ trans.choice("product.all") }}</span>
                            </span>
                            <span class="mdc-tab-indicator mdc-tab-indicator--active">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple"></span>
                        </button>
                        <button v-for="(category, index) in categories" :key="index" @click="setFilter(category)"
                            class="mdc-tab" role="tab" :id="category.slug.en" aria-selected="true" tabindex="1">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">{{ category.name[lang] || category.name.en }}</span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple"></span>
                        </button>
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { MDCTabBar } from "@material/tab-bar";
import {
    GET_CATEGORIES,
    SET_FILTER_CATEGORY_ACTION,
    GET_FILTER,
} from "../../store/shop/types";
import { mapGetters, mapActions } from "vuex";
import mixin from "../../mixin";

export default {
    mixins: [mixin],
    data: () => {
        return {
            show: false,
        };
    },
    computed: {
        ...mapGetters({
            filter: GET_FILTER,
            categories: GET_CATEGORIES,
        }),
    },
    methods: {
        ...mapActions({
            setFilter: SET_FILTER_CATEGORY_ACTION,
        }),
        isActive(category = null) {
            if (category == null) return this.filter.id ? false : true;
            else return this.filter.id === category.id;
        },
        initializeTabBars() {
            const tabBarDom = document.querySelector(".mdc-tab-bar");
            const tabBar = tabBarDom ? new MDCTabBar(tabBarDom) : null;
            console.log(tabBar);
            const category = window.location.href.split("/").pop();
            const button = document.getElementById(category);
            button && button.click();
        },
    },
    updated: function () {
        this.initializeTabBars();
    }
};
</script>

<style lang="scss">
@import "../../../sass/_variables.scss";

.mdc-tab-scroller__scroll-content {
    justify-content: center;

    .mdc-tab__text-label {
        font-family: "DM Sans", sans-serif;
    }
}

.mdc-tab {
    color: $inactive-grey;
    font-weight: bold;
    font-size: 1.125rem;
    margin: 0 50px;

    @media (max-width: $breakpoint-landing-phone) {
        margin: 0;
    }

    &--active {
        color: $black;
    }

    &__text-label {
        text-transform: capitalize !important;
    }
}

.shop-filter-component {
    .mdc-tab {
        flex-grow: 0;
        margin: 0 0.75rem;
        padding: 0 0.5rem;
        min-width: unset;

        @media (min-width: 1024px) {
            margin: 0 .5rem;
        }

        &-indicator {
            top: -5px;
        }
    }
}
</style>
